import api from "@/services/api-service";

export const findAll = (filters) => {
  return api().post("/users/find-all", filters);
};

export const create = (user) => {
  return api().post("/users", user);
};
